export interface EstadoTramitePaso {
  paso?: string;
  fecha?: string;
  comentarios?: string;
  finalizado?: boolean;
}

export interface EstadoTramiteSolicitud {
  solicitudId?: number | string;
  ordenPedidoId?: number | string;
  nombreTitular?: string;
  mecanismo?: string;
  politica?: string;
  pasos?: EstadoTramitePaso[];
}

/** Normaliza `{ data: "[...]" }` o array directo del servicio estado-solicitud/listar. */
export function parseListadoEstadoTramiteResponse(res: unknown): EstadoTramiteSolicitud[] {
  if (res == null) {
    return [];
  }
  if (Array.isArray(res)) {
    return res as EstadoTramiteSolicitud[];
  }
  if (typeof res !== 'object') {
    return [];
  }
  const data = (res as Record<string, unknown>)['data'];
  if (Array.isArray(data)) {
    return data as EstadoTramiteSolicitud[];
  }
  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      return Array.isArray(parsed) ? (parsed as EstadoTramiteSolicitud[]) : [];
    } catch {
      return [];
    }
  }
  return [];
}

function escapeHtmlText(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function escapeHtmlAttr(value: string): string {
  return escapeHtmlText(value);
}

/** Convierte comentarios del backend (con \<a href=...\>) en HTML seguro con enlaces clicables. */
export function comentarioEstadoTramiteHtml(raw: unknown): string {
  let s = String(raw ?? '').trim();
  if (!s) {
    return '';
  }
  s = s.replace(/\\</g, '<').replace(/\\>/g, '>').replace(/\\=/g, '=');

  const links: string[] = [];

  const registrarEnlace = (href: string): string => {
    const url = String(href ?? '').trim();
    if (!/^https?:\/\//i.test(url)) {
      return '';
    }
    const idx = links.length;
    links.push(
      `<a href="${escapeHtmlAttr(url)}" target="_blank" rel="noopener noreferrer">Aquí</a>`
    );
    return `__ET_LINK_${idx}__`;
  };

  s = s.replace(
    /<a\s+href\s*=\s*([^\s>]+|"[^"]*"|'[^']*')\s*[^>]*>([\s\S]*?)<\/a>/gi,
    (_match, hrefRaw: string) => registrarEnlace(String(hrefRaw).replace(/^["']|["']$/g, ''))
  );

  s = s.replace(/https?:\/\/[^\s<>"']+/gi, (url) => registrarEnlace(url));

  s = escapeHtmlText(s);
  links.forEach((linkHtml, idx) => {
    s = s.split(`__ET_LINK_${idx}__`).join(linkHtml);
  });

  return s;
}

export function tieneComentariosEstadoTramite(raw: unknown): boolean {
  return String(raw ?? '').trim().length > 0;
}
